import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { InStoreLocation } from '../models';
@Injectable({
  providedIn: 'root'
})
export class InStoreLocationService {

  constructor(
    private apiService: ApiService
  ) { }
  read(entityCode: string): Observable<InStoreLocation[]> {
    return this.apiService.get(`${this.apiService.inStoreLocation}/${entityCode}`);
  }

  create(body: InStoreLocation): Observable<InStoreLocation> {
    return this.apiService.post(this.apiService.inStoreLocation, body);
  }

  update(body: InStoreLocation): Observable<InStoreLocation[]> {
    return this.apiService.put(`${this.apiService.inStoreLocation}`, body);
  }

  delete(body: any): Observable<InStoreLocation[]> {
    return this.apiService.put(`${this.apiService.inStoreLocation}/status`, body);
  }
}
